import { lazy } from 'react';

const orderRoutes = [
    {
        exact: true,
        path: '/',
        component: lazy(() => import('../views/dashboard')),
    },
    {
        exact: true,
        path: '/dashboard',
        component: lazy(() => import('../views/dashboard')),
    },
    {
        exact: true,
        path: '/myOrders/:tab',
        component: lazy(() => import('../views/myOrders'))
    },
    {
        exact: true,
        path: '/myOrders',
        component: lazy(() => import('../views/myOrders'))
    },
    {
        exact: true,
        path: '/orders',
        component: lazy(() => import('../views/OrdersPage'))
    },
    {
        exact: true,
        path: '/orders/:id',
        component: lazy(() => import('../views/OrdersPage'))
    },
    {
        exact: true,
        path: '/order/detail/:id',
        component: lazy(() => import('../views/OrderDetail/Components/OrderDetail'))
    },
    {
        exact: true,
        path: '/NewOrders',
        component: lazy(() => import('../views/NewOrders'))
    },
    {
        exact: true,
        path: '/NewOrders/:id',
        component: lazy(() => import('../views/NewOrders'))
    },
    {
        exact: true,
        path: '/OrderSummary',
        component: lazy(() => import('../views/OrderSummary'))
    },
    {
        exact: true,
        path: '/OrderSuccess',
        component: lazy(() => import('../views/OrderSuccess'))
    },
    {
        exact: true,
        path: '/CancelOrder/:id',
        component: lazy(() => import('../views/OrdersPage/Orders/CancelOrder'))
    },
    {
        exact: true,
        path: '/QRCodeGen',
        component: lazy(() => import('../views/placeOrderFor4GiOT'))
    }
];

export default orderRoutes;
